

export const KEYS_FALTAS = {
    IdFalta: "IdFalta",
    Area: "Area",
    IdEmpleado: "IdEmpleado",
    FechaInicio: "FechaInicio",
    FechaFin: "FechaFin",
    CantidadDias: "CantidadDias",
    EmpleadoAprobadoPor: "EmpleadoAprobadoPor",
    TipoFalta: "TipoFalta",
    IdTipoFalta: "IdTipoFalta",
    FaltaPeriodo: "FaltaPeriodo",
    EstadoEmpleado: "EstadoEmpleado",
    IdEstadoEmpleado: "IdEstadoEmpleado",
    PuedeAprobar: "PuedeAprobar",
    PuedeRechazar: "PuedeRechazar",
    PuedeObservar: "PuedeObservar",
    PuedeAnular: "PuedeAnular",
    PuedeEditar: "PuedeEditar",
    SustentoFalta: "SustentoFalta",
    Justificacion: "Justificacion",
    MotivoRechazo: "MotivoRechazo",
    MotivoObservacion: "MotivoObservacion",
    MotivoAnulacion: "MotivoAnulacion",
    NombreEmpleado:"NombreEmpleado",
    Comentario: "Comentario",
    LinkProcedimiento: "LinkProcedimiento"
};